import { sendRoomBecomeAMemberAnalytic } from '../../../../shared/scripts/analytics/sendRoomBecomeAMemberAnalytic.ts';
import { UIRoomCenterSettingsModeController } from './UIRoomCenterSettingsModeController.ts';
import { UIRoomCenterSettingsSpeedController } from '../../../../shared/scripts/ui_room/UIRoomCenterSettingsSpeedController.ts';
import { UIRoomCenterSettingsMapController } from './UIRoomCenterSettingsMapController.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { UIRoomCenterShareLinkController } from './UIRoomCenterShareLinkController.ts';
import { uiManager } from '../../EntryHomepage.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { socket, uiManagerEvents } from '../../../../shared/scripts/EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
import { AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { ModeSettingEnum, RoomSettingConstants } from '@colonist/game-base-types';
import { UIRoomCenterInfoMessageController } from './UIRoomCenterInfoMessageController.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { UIRoomWarningController, WarningType } from '../../../../shared/scripts/ui_html/room_warning/UIRoomWarningController.ts';
import { UIRoomCenterSeedOrderSelectionController } from './play_order_selection/UIRoomCenterSeedOrderSelectionController.ts';
import { createDivIn, setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { RoomCreationPhase } from '@colonist/lobby-types';
import { showBecomeMemberDialog } from '../../../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
import { UIRoomSliderController } from '../../../../shared/scripts/ui_html/room/UIRoomSliderController.ts';
import { UIGameSpriteHandler } from '../../../../shared/scripts/UIGameSpriteHandler.ts';
import { UIRoomSettingsRulesController } from '../../../../shared/scripts/ui_html/room/UIRoomSettingsRulesController.ts';
import { UIRoomCenterSettingsMaxPlayersController } from '../../../../shared/scripts/ui_room/UIRoomCenterSettingsMaxPlayersController.ts';
import { UIRoomSettingsController } from '../../../../shared/scripts/ui_room/UIRoomSettingsController.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIWRoomCenterController {
    update(oldRoomState, newRoomState) {
        var _GameModeDataController_getModeDataForMode;
        this.roomState = newRoomState;
        const isGuest = UIWRoomCenterController.isGuest(newRoomState);
        this.updateTitle(newRoomState);
        this.updateScrollContainerContent();
        this.updateVisibleFooterContent(newRoomState);
        for (const sessionState of newRoomState.getSessions()){
            if (sessionState.userSessionId == socket.controller.session.id) this.checkBoxReady.checked = sessionState.isReadyToPlay;
        }
        this.modeSettingsController.update(newRoomState);
        this.mapSettingsController.update(newRoomState);
        this.rulesController.update(newRoomState);
        this.gameSpeedSettingsController.update(newRoomState);
        this.maxPlayersSettingsController.update(newRoomState);
        var _GameModeDataController_getModeDataForMode_defaultVPsToWin;
        const defaultVictoryPoints = (_GameModeDataController_getModeDataForMode_defaultVPsToWin = (_GameModeDataController_getModeDataForMode = GameModeDataController.getModeDataForMode(newRoomState.gameSetting.modeSetting)) === null || _GameModeDataController_getModeDataForMode === void 0 ? void 0 : _GameModeDataController_getModeDataForMode.defaultVPsToWin) !== null && _GameModeDataController_getModeDataForMode_defaultVPsToWin !== void 0 ? _GameModeDataController_getModeDataForMode_defaultVPsToWin : RoomSettingConstants.DEFAULT_VP_TO_WIN;
        if ((oldRoomState === null || oldRoomState === void 0 ? void 0 : oldRoomState.victoryPointsMaxAllowed) != newRoomState.victoryPointsMaxAllowed) this.victoryPointsSlider.updateSliderConfig(defaultVictoryPoints, newRoomState.victoryPointsMaxAllowed);
        this.victoryPointsSlider.setWarningThreshold(newRoomState.victoryPointsRecommendedLimit);
        this.victoryPointsSlider.setValue(newRoomState.gameSetting.victoryPointsToWin, isGuest);
        this.cardDiscardLimitSlider.setValue(newRoomState.gameSetting.cardDiscardLimit, isGuest);
        this.updateInteractabilityOfElements(newRoomState);
    }
    load(roomState) {
        this.roomState = roomState;
        this.shareLinkController.load(roomState);
        this.modeSettingsController.load(roomState);
        this.mapSettingsController.load(roomState);
        this.rulesController.load(roomState);
        this.gameSpeedSettingsController.load(roomState);
        this.maxPlayersSettingsController.load(roomState);
        this.loadFooterContent(roomState);
        setElementOnClick(this.exitButton, ()=>{
            AudioManager.play(AudioType.Click);
            uiManager.room.leaveRoom();
        });
        if (this.becomeAMemberButton) {
            if (!UIUtilsEjsVariables.isUserOnDiscord && isSubscriptionOverlayVariant()) this.becomeAMemberButton.removeAttribute('href');
            setElementOnClick(this.becomeAMemberButton, ()=>{
                if (UIUtilsEjsVariables.isUserOnDiscord) showBecomeMemberDialog('gameplay', AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral);
                else if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                sendRoomBecomeAMemberAnalytic();
            });
        }
        this.updateInteractabilityOfElements(roomState);
        this.update(undefined, roomState);
        this.hideSettingsIfBeginnerMode(roomState.gameSetting.modeSetting);
    }
    loadFooterContent(roomState) {
        // eslint-disable-next-line no-restricted-syntax
        this.checkBoxReady.onclick = (e)=>{
            e.preventDefault();
            UIRoomWarningController.runWithWarning(async (userAgreed)=>{
                if (userAgreed) this.checkBoxReady.checked = true;
                AudioManager.play(AudioType.Click);
                await UIGameSpriteHandler.continueAfterAssetsLoad();
                socket.roomClient.setReadyToStart(this.checkBoxReady.checked);
            }, WarningType.ReadyUpVPExceededRecommendedLimit, this.roomState);
        };
        setElementOnClick(this.startButton, ()=>UIRoomWarningController.runWithWarning(async ()=>{
                AudioManager.play(AudioType.Click);
                if (this.roomState != undefined) {
                    UIRoomSettingsController.snapshotRoomSettings(this.roomState, socket.controller.session.id);
                }
                await UIGameSpriteHandler.continueAfterAssetsLoad();
                socket.roomClient.startGame();
            }, WarningType.StartGameVPExceededRecommendedLimit, this.roomState));
        setElementOnClick(this.startCustomOrderSelectionButton, ()=>{
            AudioManager.play(AudioType.Click);
            socket.roomClient.startSeedOrderSelection();
        });
    }
    updateInteractabilityOfElements(newRoomState) {
        var _this_becomeAMemberButton;
        const isGuest = UIWRoomCenterController.isGuest(newRoomState);
        const isMember = UIWRoomCenterController.isMember();
        const isPlayOrderSelectionActive = newRoomState.gameSetting.playOrderSelectionActive;
        if (this.startButton.parentElement) this.startButton.parentElement.hidden = isGuest || isPlayOrderSelectionActive;
        if (this.startCustomOrderSelectionButton.parentElement) this.startCustomOrderSelectionButton.parentElement.hidden = isGuest || !isPlayOrderSelectionActive;
        if ((_this_becomeAMemberButton = this.becomeAMemberButton) === null || _this_becomeAMemberButton === void 0 ? void 0 : _this_becomeAMemberButton.parentElement) this.becomeAMemberButton.parentElement.hidden = isMember;
        if (this.imReadySpan.parentElement) this.imReadySpan.parentElement.hidden = !isGuest;
        this.modeSettingsController.updateInteractabilityOfElements(isGuest);
        this.mapSettingsController.updateInteractabilityOfElements(isGuest);
        this.rulesController.updateInteractabilityOfElements(isGuest);
        this.gameSpeedSettingsController.updateInteractabilityOfElements(newRoomState);
        this.maxPlayersSettingsController.updateInteractabilityOfElements(newRoomState);
    }
    static isGuest(roomState) {
        return socket.controller.session.id != roomState.hostSession.userSessionId;
    }
    static isMember() {
        var _ClientUserState_userState;
        var _ClientUserState_userState_items_hasMembership;
        return (_ClientUserState_userState_items_hasMembership = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) !== null && _ClientUserState_userState_items_hasMembership !== void 0 ? _ClientUserState_userState_items_hasMembership : false;
    }
    updateTitle(newRoomState) {
        const gameSettingsTitle = document.getElementById('room_center_game_settings_title');
        const titleShouldBeSeedOrderSelection = this.roomState.creationPhase == RoomCreationPhase.SeedOrderSelection && gameSettingsTitle != null;
        const newTitle = titleShouldBeSeedOrderSelection ? {
            key: 'strings:roomPage.orderSelection.seedOrderSelection.title'
        } : {
            key: 'strings:roomPage.gameSettingsTitle',
            options: {
                hash: newRoomState.gameSetting.id
            }
        };
        setElementInnerHTML(gameSettingsTitle, newTitle);
    }
    updateScrollContainerContent() {
        const shouldHideDefaultScrollContainerContent = this.roomState.creationPhase == RoomCreationPhase.SeedOrderSelection;
        for (const child of this.scrollContainer.children)child.hidden = shouldHideDefaultScrollContainerContent;
        this.seedOrderSelectionController.setScrollContainerContentVisibility(shouldHideDefaultScrollContainerContent);
    }
    updateVisibleFooterContent(roomState) {
        const footer = document.getElementById('room_center_footer');
        const shouldHideDefaultFooterContent = this.roomState.creationPhase == RoomCreationPhase.SeedOrderSelection && footer != null;
        for (const child of footer.children)child.hidden = shouldHideDefaultFooterContent;
        this.seedOrderSelectionController.setFooterContentVisibility(shouldHideDefaultFooterContent);
    }
    hideSettingsIfBeginnerMode(modeSetting) {
        const settingsOverlay = document.getElementById('room-center-settings-overlay');
        const shouldHideSettings = modeSetting == ModeSettingEnum.BeginnerModeClassic4P;
        if (settingsOverlay == null) return;
        if (shouldHideSettings) {
            this.scrollContainer.style.overflowY = 'hidden';
            settingsOverlay.style.display = 'flex';
            return;
        }
        this.scrollContainer.style.overflowY = 'scroll';
        settingsOverlay.style.display = 'none';
    }
    updateSeedOrderSelection(newRoomState, data) {
        const footer = document.getElementById('room_center_footer');
        this.seedOrderSelectionController.updateSeedOrderSelection(newRoomState, footer, data);
    }
    constructor(){
        this.DEFAULT_SLIDER_STEP = 1;
        this.roomCenterContainer = document.getElementById('room_center_mid');
        this.scrollContainer = document.getElementById('room_center_scroll');
        this.roomStartActionsContainer = document.getElementById('room_start_actions');
        const sliderContainer = createDivIn(this.scrollContainer, 'room_center_options');
        this.victoryPointsSlider = new UIRoomSliderController(sliderContainer, {
            key: 'strings:roomPage.options.vpToWin.title'
        }, RoomSettingConstants.DEFAULT_VP_TO_WIN, RoomSettingConstants.MIN_VP_TO_WIN, RoomSettingConstants.DEFAULT_VP_TO_WIN, this.DEFAULT_SLIDER_STEP, (victoryPoints)=>socket.roomClient.setVictoryPointsToWin(victoryPoints));
        this.cardDiscardLimitSlider = new UIRoomSliderController(sliderContainer, {
            key: 'strings:roomPage.options.cardDiscardLimit.title'
        }, RoomSettingConstants.DEFAULT_CARD_DISCARD_LIMIT, RoomSettingConstants.MIN_CARD_DISCARD_LIMIT, RoomSettingConstants.MAX_CARD_DISCARD_LIMIT, this.DEFAULT_SLIDER_STEP, (cardDiscard)=>socket.roomClient.setCardDiscardLimit(cardDiscard));
        this.checkBoxReady = document.getElementById('room_center_checkbox_ready');
        this.startButton = document.getElementById('room_center_start_button');
        this.startCustomOrderSelectionButton = document.getElementById('room_center_start_order_selection_button');
        this.imReadySpan = document.getElementById('room_center_im_ready');
        this.exitButton = document.getElementById('room_center_exit_button');
        this.becomeAMemberButton = document.getElementById('room_center_become_member_button');
        this.modeSettingsController = new UIRoomCenterSettingsModeController();
        this.mapSettingsController = new UIRoomCenterSettingsMapController();
        const rulesContainer = document.getElementById('room_center_rules_settings');
        this.rulesController = new UIRoomSettingsRulesController(rulesContainer);
        const gameSpeedContainer = document.getElementById('room_center_gamespeed_settings');
        const maxPlayersContainer = document.getElementById('room_center_maxplayers_settings');
        this.gameSpeedSettingsController = new UIRoomCenterSettingsSpeedController(gameSpeedContainer);
        this.maxPlayersSettingsController = new UIRoomCenterSettingsMaxPlayersController(maxPlayersContainer);
        this.shareLinkController = new UIRoomCenterShareLinkController();
        this.seedOrderSelectionController = new UIRoomCenterSeedOrderSelectionController(this.scrollContainer);
        this.infoMessageController = new UIRoomCenterInfoMessageController();
    }
}
